import { render, staticRenderFns } from "./OrmBatchingDetail.vue?vue&type=template&id=388f6708&scoped=true"
import script from "./OrmBatchingDetail.vue?vue&type=script&lang=js"
export * from "./OrmBatchingDetail.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingDetail.vue?vue&type=style&index=0&id=388f6708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f6708",
  null
  
)

export default component.exports